import { render, staticRenderFns } from "./PsiFormTrixField.vue?vue&type=template&id=2115eb64&"
import script from "./PsiFormTrixField.vue?vue&type=script&lang=js&"
export * from "./PsiFormTrixField.vue?vue&type=script&lang=js&"
import style0 from "./PsiFormTrixField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports